import { defineStore } from 'pinia'
import {
  getGoodsAddressSale,
  getGoodsAmountList,
  getGoodsCategoryCount,
  getGoodsCategoryFavor,
  getGoodsCategorySale
} from '@/service/analysis/analysis'

interface IAmountItem {
  amount: string
  title: string
  tips: string
  subtitle: string
  number1: number
  number2: number
}

interface IAnalysisState {
  goodsAmounts: IAmountItem[]
  goodsCategoryCounts: any[]
  goodsCategorySales: any[]
  goodsCategoryFavors: any[]
  goodsAddressSales: any[]
}
const useAnalysisStore = defineStore('analysis', {
  state: (): IAnalysisState => ({
    goodsAmounts: [],
    goodsCategoryCounts: [],
    goodsCategorySales: [],
    goodsCategoryFavors: [],
    goodsAddressSales: []
  }),
  actions: {
    /* 获取商品统计数据 */
    async getGoodsAmountListAction() {
      const res = await getGoodsAmountList()
      this.goodsAmounts = res.data
    },

    /* 获取商品分类个数 */
    async getGoodsCategoryCountAction() {
      const res = await getGoodsCategoryCount()
      this.goodsCategoryCounts = res.data
    },

    /* 获取商品分类销量 */
    async getGoodsCategorySaleAction() {
      const res = await getGoodsCategorySale()
      this.goodsCategorySales = res.data
    },

    /* 获取商品分类收藏 */
    async getGoodsCategoryFavorAction() {
      const res = await getGoodsCategoryFavor()
      this.goodsCategoryFavors = res.data
    },

    /* 获取城市销量 */
    async getGoodsAddressSaleAction() {
      const res = await getGoodsAddressSale()
      this.goodsAddressSales = res.data
    }
  }
})

export default useAnalysisStore
